// /frontend/src/config/constants.ts

/**
 * Contains application-wide constant values.
 *
 * @author Alexander Funke
 * @lastChange 2025-10-20
 */

export const ADMIN_EMPLOYEE_UUID = "f0b096d9-3aa9-422f-bed8-bad1f4347361";
export const HOMEAPI_COMPANY_UUID = "13e0d3ee-d151-440d-b2b6-56619aa3f064";
export const ADMIN_ROLE_UUID = "dc824b8a-f08f-4180-ba4f-353c00638ef2";
